export const WHATS_NEW_CONSTANTS = {
  COLLECTIONS: {
    MISC_REPO: "bik-miscellaneous",
    WHATS_NEW_COLLECTION: "bik-whats-new",
    ARTICLES: "articles",
  },

  FILTERS: {
    MODULE_FILTERS: ["All", "Helpdesk", "Campaigns", "Journeys", "Popups", "Manifest"],
    UPDATE_TYPE_FILTERS: ["All", "Major", "Minor"],
    DATE_FILTERS: ["Today", "Last 7 days", "Last 30 days", "Custom range"],
    STATUS_FILTERS: ["Active", "Archive"],
  },

  TABLE_COLUMNS: [
    { key: "featureTitle", label: "Feature Title", width: "200px" },
    { key: "featureDescription", label: "Feature Description", width: "350px" },
    { key: "visibility", label: "Visibility", width: "100px" },
    { key: "updates", label: "Updates", width: "80px" },
    { key: "showInFeed", label: "In Feed", width: "100px" },
    { key: "module", label: "Module", width: "180px" },
    { key: "date", label: "Date", width: "100px" },
    { key: "visibleUntil", label: "Visible Until", width: "100px" },
    { key: "actions", label: "Actions", width: "200px" },
  ],

  DEFAULT_IMAGE:
    "https://firebasestorage.googleapis.com/v0/b/bik-ai.appspot.com/o/growth%2Fwhats-new%2Fdefault-image.png?alt=media&token=default-token",

  UI: {
    ROW_HEIGHT: "80px",
    SEARCH_PLACEHOLDER: "Search...",
    LOADING_TEXT: "Loading...",
    NO_RESULTS_TEXT: "No features found matching your filters",
    DELETE_CONFIRMATION: "Please keep atleast one article",
    NO_VIDEO_TEXT: "No video available",
  },
} as const;

export type ModuleFilter =
  (typeof WHATS_NEW_CONSTANTS.FILTERS.MODULE_FILTERS)[number];
export type UpdateTypeFilter =
  (typeof WHATS_NEW_CONSTANTS.FILTERS.UPDATE_TYPE_FILTERS)[number];
export type DateFilter =
  (typeof WHATS_NEW_CONSTANTS.FILTERS.DATE_FILTERS)[number];
export type StatusFilter =
  (typeof WHATS_NEW_CONSTANTS.FILTERS.STATUS_FILTERS)[number];
